import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import useRequest from "../../../context/useRequest";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../templates/Sidebar/Sidebar";
import Input from "../../atoms/Input/Input";
import FormCountryCodes from "../../molecules/Form/FormCountryCodes";
import Swal from "sweetalert2";

const UpdateProfile = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { sendRequest } = useRequest();

  const [originalProfile] = useState(state?.profileDetails || {});
  const [formData, setFormData] = useState(state?.profileDetails || {});
  const [isFieldErrors, setIsFieldErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const profileUpdateSubmitHandler = async (e) => {
    e.preventDefault();

    const formRegister = new FormData();
    formRegister.append("id", formData.id);
    formRegister.append("title", formData.title || "");
    formRegister.append("first_name", formData.first_name || "");
    formRegister.append("last_name", formData.last_name || "");
    formRegister.append("email", formData.email || "");
    formRegister.append("country_code", formData.country_code || "");
    formRegister.append("phone", formData.phone || "");
    formRegister.append("vfsGlobalId", "105");

    console.log("🚀 Sending Form Data:");
    for (let pair of formRegister.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await sendRequest({
        method: "POST",
        url: "/auth/updateUser",
        body: formRegister,
      });

      console.log("✅ Server Response:", response);

      if (response.status) {
        Swal.fire({
          title: "Details updated successfully",
          icon: "success",
        }).then(() => {
          // Use updated values from formData (not the response if backend is outdated)
          const updatedUser = {
            ...originalProfile,
            ...formData,
            // Email verified at might get reset, so handle that
            email_verified_at:
              formData.email !== originalProfile.email
                ? null
                : originalProfile.email_verified_at,
          };

          navigate("/profile", {
            state: { updatedUser },
          });
        });
      } else {
        Swal.fire({
          title: "Details could not be updated",
          text: response?.message || "",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("❌ Update Error:", error);
      Swal.fire({
        title: "An error occurred",
        text: error.message || "Something went wrong.",
        icon: "error",
      });
    }
  };

  return (
    <section className="profile section-padding">
      <Container>
        <Row>
          <Col className="col-12 col-md-3">
            <Sidebar />
          </Col>
          <Col className="col-12 col-md-9">
            <div className="profile--detail">
              <div className="profile--detail-title mb-3">
                <h2 className="h3">Edit Profile</h2>
                <p className="mb-0">Edit Your Europcar account details</p>
              </div>
              <form
                onSubmit={profileUpdateSubmitHandler}
                className="login-form--item-left-form mt-3"
              >
                <div className="login-form--item-left-form-row">
                  <div className="form-group input-group login-form--item-left-form-input">
                    <Input
                      type="text"
                      name="first_name"
                      placeholder="First Name"
                      value={formData.first_name || ""}
                      onChange={handleChange}
                      className="form-control"
                      label={
                        <span>
                          First Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required
                    />
                    {isFieldErrors.first_name && (
                      <p className="error-message">{isFieldErrors.first_name}</p>
                    )}
                  </div>
                  <div className="form-group input-group login-form--item-left-form-input">
                    <Input
                      type="text"
                      name="last_name"
                      placeholder="Last Name"
                      value={formData.last_name || ""}
                      onChange={handleChange}
                      className="form-control"
                      pattern="^[A-Za-z]+$"
                      label={
                        <span>
                          Last Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                    />
                    {isFieldErrors.last_name && (
                      <p className="error-message">{isFieldErrors.last_name}</p>
                    )}
                  </div>
                </div>

                <div className="form-group input-group login-form--item-left-form-input">
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email || ""}
                    onChange={handleChange}
                    className="form-control"
                    label={
                      <span>
                        Email<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                  />
                  {isFieldErrors.email && (
                    <p className="error-message">{isFieldErrors.email}</p>
                  )}
                </div>

                <div className="login-form--item-left-form-row">
                  <div className="form-group input-group login-form--item-left-form-input">
                    <FormCountryCodes
                      value={formData.country_code || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          country_code: e.target.value,
                        }))
                      }
                    />
                    {isFieldErrors.country_code && (
                      <p className="error-message">{isFieldErrors.country_code}</p>
                    )}
                  </div>

                  <div className="form-group input-group login-form--item-left-form-input">
                    <Input
                      type="text"
                      name="phone"
                      placeholder="Phone No"
                      value={formData.phone || ""}
                      onChange={handleChange}
                      className="form-control"
                      pattern="^[0-9]*$"
                      minLength="8"
                      maxLength="14"
                      label={
                        <span>
                          Phone No<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                    />
                    {isFieldErrors.phone && (
                      <p className="error-message">{isFieldErrors.phone}</p>
                    )}
                  </div>
                </div>

                <div className="mb-3 mt-3">
                  <button type="submit" name="submit" className="btn-custom">
                    Update Profile
                  </button>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UpdateProfile;
